// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__4YDHh {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 25px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_header__z0iOK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
  gap: 1rem;

  @media (max-width: 550px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.style_header__z0iOK .style_caption__3Yj3w {
  @media (max-width: 750px) {
    width: 65%;
  }

  @media (max-width: 500px) {
    width: auto;
  }
}

.style_headerTitle__WOPzJ {
  @media (max-width: 550px) {
    font-size: 1.2rem !important;
  }
}

.style_headerSubtitle__Gm\\+Cy {
  @media (max-width: 550px) {
    display: none;
  }
}

.style_searchHeader__NW1\\+f {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  width: 100%;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.style_counter__icpgJ {
  display: flex;
  flex-direction: column;
}

.style_searchBox__olVp4 {
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 100% !important;
    max-width: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Supplies/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,SAAS;;EAET;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;;EAET;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  padding: 25px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n  gap: 1rem;\n\n  @media (max-width: 550px) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.header .caption {\n  @media (max-width: 750px) {\n    width: 65%;\n  }\n\n  @media (max-width: 500px) {\n    width: auto;\n  }\n}\n\n.headerTitle {\n  @media (max-width: 550px) {\n    font-size: 1.2rem !important;\n  }\n}\n\n.headerSubtitle {\n  @media (max-width: 550px) {\n    display: none;\n  }\n}\n\n.searchHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  width: 100%;\n  gap: 1rem;\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.counter {\n  display: flex;\n  flex-direction: column;\n}\n\n.searchBox {\n  flex-shrink: 0;\n\n  @media (max-width: 900px) {\n    width: 100% !important;\n    max-width: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__4YDHh`,
	"header": `style_header__z0iOK`,
	"caption": `style_caption__3Yj3w`,
	"headerTitle": `style_headerTitle__WOPzJ`,
	"headerSubtitle": `style_headerSubtitle__Gm+Cy`,
	"searchHeader": `style_searchHeader__NW1+f`,
	"counter": `style_counter__icpgJ`,
	"searchBox": `style_searchBox__olVp4`
};
export default ___CSS_LOADER_EXPORT___;
